import React, { Component } from "react";
import {ATTR_OBJ_ID, OBS_PICTS, STR_YES} from "../prodect/ProsConnect";
import * as prosConnect from "../prodect/ProsConnect";
import {ATTR_PICTURE_LOC_H, ATTR_PICTURE_LOC_W, ATTR_HAS_PICTURE_LOC} from "../prodect/ProsConnect";
import {ATTR_OBJ_TYPE} from "../prodect/ProsConnect";
import Spacer from "../components/Spacer";
import BasicButton from "../components/BasicButton";
import {clearFilteredObsIds, filteredObsChangeCount, getFilteredObsIds} from "./ProjectReportTable";
import UiImage from "../components/UiImage";

const DEFERRED_REFRESH_DELAY = 4

/**
 * When component is mounted project location picture images are known.
 * Table UI is used to filter selected observation rows - table filtering
 * provides
 *  - filteredObsChangeCount - incremented each time filter been changed
 *  - function getFilteredObsIds() to request filtering result by
 *
 * Table component uses "deferred rendering" so we also need to render after filter been changed
 * To render markers need to wait for picture image is loaded to know size in html dom
 */

export default class LocationPictureList extends Component
{
    constructor(props) {
        super(props);
        this.locationPictureRefreshTimer = undefined;
        this.state = {
            projectLocationPictures: [],
            filteredObsList: [],
            refreshCounter: 0,
            prevObjCount: 0
        }
        this.state.zoomedLocationPicture = null
        this.prevFilteredChangeCount = 0
        this.deferredRefreshCounter = 0
        this.loadedImages = 0
        this.imagesWithLocations = 0
        this.hasLocImages = false
    }

    locationImagesFinishedLoading() {
        if(!this.hasLocImages && this.imagesWithLocations.length < 1) return true
        return this.loadedImages >= this.imagesWithLocations
    }

    locationPictureRefreshTimerCancel() {
        if (this.locationPictureRefreshTimer) {
            clearInterval(this.locationPictureRefreshTimer)
        }
    }

    updateFilteredObsList (activeProject) {
        let obsList = getFilteredObsIds().map(
            obsId => activeProject.objs.find(
                obj => obj[ATTR_OBJ_ID] === obsId)
        )
        this.setLocationsInPictures(obsList)
        this.setState({
            filteredObsList: obsList,
            refreshCounter: this.state.refreshCounter+1
        })
    }

    /**
     *  Periodic timer used for two purposes
     *  - deferred trigger to re-render when a location picture image been downloaded
     *      picture image does not need to be loaded completely bet need to know its size
     *      to compute marker location
     *  - check if table filtering been changed that reflects to shown locations
     */
    periodicTimer() {
        let activeProject = prosConnect.getActiveProject()
        if (this.prevFilteredChangeCount !== filteredObsChangeCount) {
            this.prevFilteredChangeCount = filteredObsChangeCount
            this.deferredRefreshCounter = DEFERRED_REFRESH_DELAY
            return
        }
        if (activeProject && this.state.prevObjCount !== activeProject.objs.length) {
            this.setState({
                prevObjCount: activeProject.objs.length
            })
            this.setProjectLocationPictures()
        }
        if (!activeProject || this.deferredRefreshCounter <= 0) { return }
        if (this.locationImagesFinishedLoading()) {
            this.deferredRefreshCounter--
        }
        this.updateFilteredObsList (activeProject)
    }

    componentDidMount() {
        // prosLogX("LocationPictureList:componentDidMount()");
        clearFilteredObsIds()
        this.locationPictureRefreshTimer = setInterval(() => {
            this.periodicTimer()
        }, 400)
    }

    /**
     * Remove period timer event listener
     */
    componentWillUnmount() {
        this.locationPictureRefreshTimerCancel();
    }

    /**
     * Make list of project location pictures with caption text
     */
    setProjectLocationPictures() {
        let project = prosConnect.getActiveProject()
        if (!project) {
            this.setState({
                projectLocationPictures: [],
                prevObjCount: 0
            })
        }
        let projectLocationPictures = []
        let locationPictureObj = undefined
        let locationPictureListId = project.getLocationPictureListId()
        project.objs.forEach(item => {
            if (item[ATTR_OBJ_ID].indexOf(locationPictureListId) === 0) {
                // location picture list item
                if (prosConnect.isPictureItem(item)) {
                    // location picture
                    let imagePath = prosConnect.getItemImagePath(item)
                    locationPictureObj = {
                        imagePath: imagePath,
                        caption: '',
                        locations: []
                    }
                    projectLocationPictures.push(locationPictureObj)
                }
                else if (locationPictureObj && !locationPictureObj.ui_caption &&
                    item[ATTR_OBJ_TYPE] === prosConnect.OBJ_TYPE_ITM) {
                    // next comment to a picture is caption text
                    locationPictureObj.ui_caption = prosConnect.getItemText(item, true)
                    locationPictureObj = undefined
                }
            }
        });
        this.setState({ projectLocationPictures: projectLocationPictures })
    }

    /**
     * Update filtered OBS picture coordinates to location pictures.
     * @param {object[]} List of filtered observations
     * @returns {object[]} List of Location Image objects and with a list of locations 'ui_locations'
     */
    setLocationsInPictures(observations) {
        this.state.projectLocationPictures.forEach( locPict => {
            locPict.locations.length = 0
        })
        observations.forEach(obs => {
            if (obs && obs.hasOwnProperty(OBS_PICTS)) {
                obs[OBS_PICTS]
                    .forEach(pict => {
                        if (
                            pict[ATTR_OBJ_TYPE] === prosConnect.OBJ_TYPE_ITM_PICT_LOC &&
                            pict[ATTR_HAS_PICTURE_LOC] === STR_YES &&
                            pict.hasOwnProperty(ATTR_PICTURE_LOC_W) &&
                            pict.hasOwnProperty(ATTR_PICTURE_LOC_H)) {
                            let imagePath = prosConnect.getItemImagePath(pict);
                            let locationPictureObj = this.state.projectLocationPictures.find(locPict =>
                                imagePath === locPict.imagePath);
                            if (locationPictureObj) {
                                if (!locationPictureObj.locations.find(loc => loc.key === pict.obj_id)) {
                                    locationPictureObj.locations.push({
                                        obsId: obs.obj_id,
                                        key: pict.obj_id,
                                        imagePath: imagePath,
                                        x: pict[ATTR_PICTURE_LOC_W],
                                        y: pict[ATTR_PICTURE_LOC_H],
                                    })
                                }
                            }
                        }
                    })
            }
        })
    }

    /**
     * Get list of markers for rendering for single image
     * 
     * @param {object[]} locationImageObjects Array of objects holding information needed for rendering
     * @param {string} imagePath Path for image that we want location markers for
     * 
     * @returns {object[]} Render-ready array of marker elements. These are used for one location image.
     */
    renderLocationMarkerElements(locationImageObject) {
        return locationImageObject.locations.map(marker => {
            let markerClass = (this.props.selectedObsId === marker.obsId ? "marker-active marker-pin_blue": "marker-pin")
            let obs = prosConnect.getObjById(marker.obsId)
            if (!obs || !obs.hasOwnProperty('ui_text')) {
                return null
            }
            return <div
                key={marker.key}
                title={obs.ui_text}
                style={{
                    left: marker.x * 100 + '%',
                    top: marker.y * 100 + '%'
                }}
                onClick={evt => {
                    evt.stopPropagation()
                    this.props.setActiveObsFromLocationPictureList(obs)
                }}
                className={"marker " + markerClass}>
            </div>
        })
    }

    /**
     * Function to get main content for rendering
     * 
     * @param {object} locationImageObject location image path and list of locations
     * 
     * @returns {object} html to show image with location dots
     */
    setZoomedPicture(obj) {
        let zoomedObj = JSON.stringify(obj) === JSON.stringify(this.state.zoomedLocationPicture) ? null : obj
        this.setState({ zoomedLocationPicture: zoomedObj })
    }

    renderHtmlElementsForLocationImageObject(locationImageObject) {
        if (locationImageObject.locations.length < 1) {
            return null
        }
        let imagePath = locationImageObject.imagePath
        let zoomedObject = this.state.zoomedLocationPicture ? this.state.zoomedLocationPicture.imagePath : null
        return <div key={imagePath} className={"box-media" + (zoomedObject === imagePath ? " width-100 active" : "")}>
            <div className={"media media-image"}>
                <UiImage
                    imageSrc={imagePath}
                    onImageLoad={evt => {
                        this.loadedImages++
                    }}
                    imageMarkers={this.renderLocationMarkerElements(locationImageObject)}
                    showFullImage={true}
                    action={() => this.setZoomedPicture(locationImageObject)}
                />
            </div>
            <div className={"media-controls btn-set padding-sm"}>
                <BasicButton
                    icon={zoomedObject === imagePath ? "minimize" : "expand"}
                    action={() => this.setZoomedPicture(locationImageObject)}
                    size={"md"}
                />
            </div>
            <footer>
                <p>{locationImageObject.ui_caption}</p>
            </footer>
        </div>
    }

    render() {
        if (this.state.projectLocationPictures.length < 1) {
            return null
        }
        let picList = []
        this.state.projectLocationPictures.forEach(locationImageObject => {
            if (locationImageObject.locations.length > 0) {
                picList.push(this.renderHtmlElementsForLocationImageObject(locationImageObject))
            }
        })
        this.imagesWithLocations = picList.length
        this.hasLocImages = picList.length > 0
        if(!this.hasLocImages) return null
        require("./assets/scss/LocationPictureList.scss")
        return <div className={"location-picture-list"}>
                <BasicButton
                    btnClass={"2nd"}
                    label={"Kirjausten sijainnit"}
                    icon={"chevron-" + (this.props.locationPictureListVisibility ? "up" : "down")}
                    selected={this.props.locationPictureListVisibility}
                    action={() => {this.props.toggleVisibilityOfLocationPictureList()}}
                />
                <Spacer size={"lg"}/>
                {this.props.locationPictureListVisibility ? <div className={"grid-container grid-flex-2_sm grid-flex-4_lg grid-flex-6_xxl"}>{picList}</div> : null}
            </div>
    }
}
